<div class="centaur-topnav">
  <!-- Hamburger (mobile only) -->
  @if (isMobile()) {
  <button
    (click)="menuToggle.emit()"
    class="nav-hamburger"
    aria-label="Toggle menu"
  >
    <i class="pi pi-bars"></i>
  </button>
  }

  <!-- App Logo (left) -->
  <div class="centaur-logo">
    <img src="/images/centaurwhitelogo.png" alt="Centaur" class="centaur-app-logo" />
  </div>

  <!-- Title with CVX logo (centered) -->
  <div class="nav-title-wrap">
    <img src="/images/CVX-Logo.png" alt="Chevron" class="cvx-logo" />
    <h1 class="centaur-title">
      {{ isMobile() ? 'Centaur' : 'Centaur Workflow Management' }}
    </h1>
  </div>

  <div class="centaur-topnav__actions">
    <div #accountMenuHost class="centaur-account-menu-wrap">
      <button
        [attr.aria-expanded]="accountMenuOpen()"
        [attr.aria-label]="'nav.profile' | translate"
        (click)="toggleAccountMenu()"
        type="button"
        class="centaur-avatar-btn"
      >
        <span class="centaur-avatar-btn__initials">{{ avatarInitials() }}</span>
      </button>

      @if (accountMenuOpen()) {
      <div class="centaur-account-menu" role="menu">
        <div class="centaur-account-menu__identity">
          <span class="centaur-account-menu__name">{{ userDisplayName() }}</span>
          @if (userEmail()) {
          <span class="centaur-account-menu__email">{{ userEmail() }}</span>
          }
          @if (userRole()) {
          <span class="centaur-account-menu__role">{{ userRole() }}</span>
          }
        </div>

        @if (isAuthorized()) {
        <div class="centaur-account-menu__divider"></div>

        <button
          (click)="openProfileDialog()"
          type="button"
          class="centaur-account-menu__action"
        >
          <i class="pi pi-user"></i>
          <span>{{ 'nav.profile' | translate }}</span>
        </button>
        }
      </div>
      }
    </div>
  </div>
</div>
